import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full bg-gray-50 border-t border-gray-200">
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-8">
        <div className="flex flex-col items-center text-center gap-2">
          <Link
            to="/"
            className="text-base font-bold text-gray-700 hover:text-sphere-orange-dark transition-colors"
          >
            アイチモータース
          </Link>
          <p className="text-xs text-gray-500 leading-relaxed">
            車検・整備・板金塗装・LED取付の自動車整備専門店
          </p>
        </div>
        <div className="border-t border-gray-200 mt-6 pt-4 text-center">
          <p className="text-xs text-gray-400">© アイチモータース</p>
        </div>
      </div>
    </footer>
  );
}
